import { useNavigate } from "react-router-dom";
import { startTransition } from "react";

export function useSafeNavigate() {
    const navigate = useNavigate();

    return (path: string, options?: any) => {
        startTransition(() => {
            navigate(path, options);
        });
    };
}
